module.exports = __webpack_public_path__ + "static/img/teach_head.ef9ed50e.svg";